exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle {\n  display: inline-block;\n  border: solid 2px #5A5652;\n  font-size: 11px;\n  height: 16px;\n  width: 28px;\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n}\n.toggle div {\n  width: 10px;\n  height: 10px;\n  top: 1px;\n  left: 2px;\n  position: absolute;\n  -webkit-transition: background 0.2s, left 0.5s;\n  transition: background 0.2s, left 0.5s;\n  border-radius: 50%;\n  background: #5A5652;\n  pointer-events: none;\n}\n.toggle.checked {\n  background: #5A5652;\n}\n.toggle.checked div {\n  left: 13px;\n  background: #ECEBE7;\n}\n", ""]);

// exports
